import { Directive, forwardRef, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, Validator } from "@angular/forms";
import { validationRegex } from "@obg/ngx.global";

@Directive({
	selector: "[obgNumericRange]",
	providers: [
		{
			provide: NG_VALIDATORS,
			// eslint-disable-next-line @angular-eslint/no-forward-ref
			useExisting: forwardRef(() => NumericRangeValidatorDirective),
			multi: true,
		},
	],
})
export class NumericRangeValidatorDirective implements Validator {
	@Input() obgNumericRange: { min: number; max: number } | undefined;

	validate(control: AbstractControl): { range: boolean } | null {
		return this.obgNumericRange &&
			control.value &&
			control.value.toString().match(validationRegex.realNumber) &&
			parseFloat(control.value) >= this.obgNumericRange.min &&
			parseFloat(control.value) <= this.obgNumericRange.max
			? null
			: { range: false };
	}
}
